import { MailPromo } from 'almanac-ui/icons/blaze/32'
import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { additionalInfo } from './shared/additionalInfo'
import { audience } from './shared/audience'
import { avoid } from './shared/avoid'
import { callToAction } from './shared/callToAction'
import { count } from './shared/count'
import { includeImages } from './shared/includeImages'
import { productDescription } from './shared/productDescription'
import { productName } from './shared/productName'
import { brandVoiceId, tone } from './shared/voiceTones'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.PromotionalEmailSequence,
  steps: ['Email Context & Goals', 'Generate Emails'],
  submitLabel: 'Generate Emails',
  icon: MailPromo,
  title: TextChannels[ChannelType.PromotionalEmailSequence].name,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183790/Home%20Card%20Previews/hvua8knsjg71xznryi4a.png',
}

const fields = {
  count: count.default(3).min(1).max(7).meta({ label: 'How many emails do you want in this sequence?' }),
  goal: string()
    .default('')
    .required()
    .meta({
      label: 'Describe the objective of your promo sequence',
      placeholder: 'Describe the goal(s) of your email sequence',
      snippets: true,
      rows: 3,
    })
    .transform(safify),
  call_to_action: callToAction.meta({ rows: 3 }),
  audience: audience.meta({
    label: 'Who is the target audience?',
    placeholder: 'Who is the desired reader of your emails?',
    rows: 3,
  }),
  product_name: productName.meta({ rows: 3 }),
  product_description: productDescription.meta({ rows: 3 }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  tone,
  source_material_ids: sourceMaterialIds,
  language,
  include_images: includeImages,
  length: string()
    .default('')
    .meta({
      label: 'Word count per email',
      placeholder: 'Approximate length for each email',
      collapsible: true,
      autoFill: true,
    })
    .transform(safify),
  avoid: avoid.meta({ collapsible: true }),
  additional_info: additionalInfo.meta({ collapsible: true }),
}

export const PromotionalEmailSequenceSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const PromotionalEmailMultiStepSchema: MultiStepSchema<ChannelType.PromotionalEmailSequence> = {
  steps: [
    PromotionalEmailSequenceSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.PromotionalEmailSequence,
    channel: ChannelType.PromotionalEmailSequence,
  },
}
